import React from 'react';
import FadeIn from './FadeIn';

const speakers = [
  { name: 'Dr. Beckely Ebah', role: 'Board Chair, LLC 2026', namePos: 'top' },
  { name: 'Mr. Vishi', role: 'Business Development, LLC', namePos: 'bottom' },
  { name: 'Ms. Laure Kamgno', role: 'Head of Communication, LLC', namePos: 'top' },
  { name: 'Kevin Njike', role: 'Career Coach & Entrepreneur', namePos: 'bottom' },
  { name: 'Grace Ngo’o', role: 'VP Talent, Orange Cameroon', namePos: 'bottom' },
  { name: 'Marc Tchamba', role: 'CTO, StartupHub Douala', namePos: 'top' },
  { name: 'Aisha Moukouri', role: 'HR Director, MTN Cameroon', namePos: 'bottom' },
  { name: 'Prof. Alain Fosto', role: 'Future of Work Researcher', namePos: 'top' },
];

function PersonIcon() {
  return (
    <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
    </svg>
  );
}

export default function Speakers() {
  return (
    <section className="speakers-section" id="speakers">
      <div className="container">
        <FadeIn>
        <div className="section-heading-row">
          <h2 className="section-heading-xl">KEYNOTE<br />SPEAKERS</h2>
          <div className="section-sub">
            10+ national &amp; international speakers at LLC 2026.
          </div>
        </div>
        </FadeIn>

        <FadeIn delay={1}>
        <div className="speakers__grid">
          {speakers.map((s, i) => (
            <div
              key={i}
              className={`speaker-card speaker-card--${s.namePos === 'top' ? 'name-top' : 'name-bottom'}`}
            >
              <div className="speaker-card__photo-placeholder">
                <PersonIcon />
              </div>
              {s.namePos === 'top' && (
                <div className="speaker-card__info" style={{ alignSelf: 'flex-start' }}>
                  <div className="speaker-card__name">{s.name}</div>
                </div>
              )}
              {s.namePos === 'bottom' && (
                <div className="speaker-card__info" style={{ alignSelf: 'flex-end' }}>
                  <div className="speaker-card__name">{s.name}</div>
                  <div className="speaker-card__role">{s.role}</div>
                </div>
              )}
              {s.namePos === 'top' && (
                <div className="speaker-card__info" style={{ alignSelf: 'flex-end' }}>
                  <div className="speaker-card__role">{s.role}</div>
                </div>
              )}
            </div>
          ))}
        </div>
        </FadeIn>

        <FadeIn delay={2}>
          <div className="speakers__footer">
            <button className="btn-outline">And more &#8599;</button>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
